import Component from '../core/Component'
import EventBus from '../core/EventBus'

const STATES = {
    ACTIVE: 'is-active',
    HIDDEN: 'is-hidden',
}

export default class BackgroundOverlay extends Component {
    constructor(element) {
        super(element)
    }

    prepare() {
        EventBus.on('showOverlay', this.showYourself)
        EventBus.on('hideOverlay', this.hideYourself)
    }

    destroy () {
        EventBus.off('showOverlay', this.showYourself)
        EventBus.off('hideOverlay', this.hideYourself)
    }

    showYourself = () => {
        this.element.classList.remove(STATES.HIDDEN)
        this.element.classList.add(STATES.ACTIVE)
    }

    hideYourself = () => {
        this.element.classList.add(STATES.HIDDEN)
        this.element.classList.remove(STATES.ACTIVE)
    }
}
